import { ServiceBay, ServiceBaySchedule } from "../models/serviceBay";
import { OccurrenceDto } from "./occurrenceDto";

export const ServiceBayDto = (data: any): ServiceBay => {
  return {
    id: data.id,
    name: data.name,
  };
};

export const ServiceBayScheduleDto = (data: any, occurrence?: any): ServiceBaySchedule => {
  return {
    id: data.id,
    occurrence: occurrence ? OccurrenceDto(occurrence) : undefined,
    serviceBay: ServiceBayDto(data.serviceBay),
    startDate: data.startDate ? new Date(data.startDate) : undefined,
    startHour: data.startDate ? new Date(data.startDate) : undefined,
    endDate: data.endDate ? new Date(data.endDate) : undefined,
    endHour: data.endDate ? new Date(data.endDate) : undefined,
  };
};